import React from 'react';
import { Page } from '../../components';
import DhobaraPageLayout from '../../components/DhobaraPageLayout/DhobaraPageLayout';
import css from './ReturnsPage.module.css';

const ReturnsPage = () => (
  <Page
    title="Returns Policy | Dhobara"
    description="Dhobara's returns policy: a 3-day inspection window, valid reasons for return, free return shipping, and refund timelines for buyers and sellers."
    scrollingDisabled={false}
  >
  <DhobaraPageLayout>
    <div className={css.pageHeader}>
      <span className={css.eyebrow}>Policies</span>
      <h1 className={css.pageTitle}>Returns Policy</h1>
    </div>
    <div className={css.content}>
      <p className={css.intro}>
        We want every Dhobara purchase to feel right. Our returns policy is designed to protect buyers while being fair to sellers.
      </p>

      <h2 className={css.sectionHeading}>3-Day Inspection Window</h2>
      <p className={css.para}>Once your order is delivered, you have <strong>3 calendar days</strong> to inspect the item and initiate a return. After 3 days, all sales are final.</p>
      <p className={css.para}>To initiate a return, email <a href="mailto:admin@dhobara.com">admin@dhobara.com</a> within your inspection window with your order number and the reason for return.</p>

      <h2 className={css.sectionHeading}>Valid Reasons for Return</h2>
      <p className={css.para}>Returns are accepted when the item is materially different from how it was described in the listing. Accepted reasons include:</p>
      <ul className={css.bullets}>
        <li>Item is not as described in the listing</li>
        <li>Significant defects or damage not disclosed by the seller</li>
        <li>Wrong item received</li>
        <li>Authenticity concerns (contact us immediately)</li>
      </ul>
      <p className={css.para}>We do not accept change-of-mind returns. Please review all photos, condition notes, and measurements carefully before purchasing.</p>

      <h2 className={css.sectionHeading}>Return Shipping</h2>
      <p className={css.para}>If your return is approved, Dhobara will provide a return UPS shipping label at no cost to you — we cover the full cost of return shipping.</p>
      <p className={css.para}>Items must be returned in the same condition they were received, with original packaging and tags where applicable. You must drop the item off at a UPS location within <strong>2 business days</strong> of receiving the return label.</p>

      <h2 className={css.sectionHeading}>Refunds</h2>
      <p className={css.para}>Once the returned item is received and inspected, refunds will be processed in full within <strong>5 business days</strong>. Refunds are issued to the original payment method.</p>

      <h2 className={css.sectionHeading}>What Is Not Covered</h2>
      <ul className={css.bullets}>
        <li>Change of mind or buyer's remorse</li>
        <li>Items that do not fit — please review all sizing information before purchasing</li>
        <li>Minor variations in colour due to photography or screen differences</li>
        <li>Returns initiated after the 3-day inspection window</li>
        <li>Items returned in a different condition than received</li>
      </ul>

      <h2 className={css.sectionHeading}>Seller Notice of Returns</h2>
      <p className={css.para}>If a buyer initiates a return, the item will be shipped back to the seller. Sellers have 2 days from receipt of the returned item to raise a dispute if the item was not returned in its original condition. Disputes must be submitted with photographic evidence to <a href="mailto:admin@dhobara.com">admin@dhobara.com</a>.</p>
      <p className={css.para}>Returned items are automatically relisted on Dhobara without the seller needing to resubmit.</p>

      <h2 className={css.sectionHeading}>Questions?</h2>
      <p className={css.para}>Contact us at <a href="mailto:admin@dhobara.com">admin@dhobara.com</a> — we typically respond within 1–2 business days.</p>
    </div>
  </DhobaraPageLayout>
  </Page>
);

export default ReturnsPage;
